export default {
  analysis: () => import("/app/layouts/analysis.vue").then(m => m.default || m),
  default: () => import("/app/layouts/default.vue").then(m => m.default || m)
}